import { BulletWrapper } from "./skill-card.styles"

const SkillBullet = ({ name }) => (
    <BulletWrapper>
        <h3>{name}</h3>
    </BulletWrapper>
)

export default SkillBullet;